import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type EventDetails } from '~entities/events/index';
import { invalidateSessionLinkedCounts } from '~entities/session/api/get-class-event-count-session-by-id';

import { baseAPI } from '~shared/api/base-api';

interface BulkDeleteEventsParams {
  eventIds: Array<string>;
}

export const bulkDeleteEventsAPI = async (params: BulkDeleteEventsParams) => {
  const response = await baseAPI.delete<Array<EventDetails>>(
    '/events/batch/all',
    {
      data: params.eventIds,
    },
  );
  return response.data;
};

export const useBulkDeleteEvents = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: BulkDeleteEventsParams) => bulkDeleteEventsAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['events'] });
      void invalidateSessionLinkedCounts(queryClient);
    },
  });
};
